import { AnalyticsAction } from '../models/AnalyticsAction';
import { IAnalyticsContext, IAnalyticsProvider } from './AnalyticsProvider';

export class MockAnalyticsProvider implements IAnalyticsProvider {
  call(action: AnalyticsAction): boolean {
    console.log('🦄.call', action);
    return true;
  }

  time(): boolean {
    return true;
  }

  setContext(context: IAnalyticsContext): void {
    console.log('🦄', context);
  }

  setSdkEnvironment(env: string): void {
    console.log('🦄', env);
  }

  setPaymentIntent(intent: string): void {
    console.log('🦄', intent);
  }
}
